/**
 * Created by tomers on 3/1/2015.
 */
define(function (require) {
    "use strict";

    var BaseFeatureController = require("personalization-controllers/BaseFeatureController");
    var DefaultAgentStatusEditView = require("personalization-web-agent-views/DefaultAgentStatusEditView");
    var SiteSettingsModel = require("models/SiteSettingsModel");
    var Settings = require("codeTables/settings.json");


    var DefaultAgentStatusEditController = {};

    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {

        DefaultAgentStatusEditController = BaseFeatureController.extend({
            initialize: function(options) {
                this._initialize(options);
            },


            getEditView: function() {
                return this._getEditView();
            },


            _initialize: function (options) {
                LEPersonalization.logger.info("initializing", "DefaultAgentStatusEditController:_initialize");

                this.currentDefaultAgentStatus = options.currentDefaultAgentStatus;
                this.siteSettingsModel = options.siteSettingsModel;

                this._createView(options);
                this._bindEvents();
            },

            _createView: function(options) {
                LEPersonalization.logger.debug("create the edit view", "DefaultAgentStatusEditController:_createView");

                this.defaultAgentStatusEditView = new DefaultAgentStatusEditView({
                    anchorSelector:options.featureOptions.anchorSelector,
                    collection: LE.siteSettings.agentStatusSettings.getAgentStatusCollection(),
                    currentDefaultAgentStatus: this.currentDefaultAgentStatus
                });

                LEPersonalization.logger.debug("the created edit view", "DefaultAgentStatusEditController:_createView", this.defaultAgentStatusEditView);
            },

            _bindEvents: function() {
                LEPersonalization.logger.debug("binding events", "DefaultAgentStatusEditController:_bindEvents");
                this.listenTo(this.defaultAgentStatusEditView, "defaultAgentStatus:change", this._onChange);
                this.listenTo(this.defaultAgentStatusEditView, "defaultAgentStatus:save", this._onSave);
                this.listenTo(this.defaultAgentStatusEditView, "defaultAgentStatus:cancel", this._onCancel);
            },

            _onChange: function(selectedStatus) {
                LEPersonalization.logger.info("status was changed", "DefaultAgentStatusEditController:_onChange", selectedStatus);
                this.currentDefaultAgentStatus = selectedStatus;
            },

            _onSave: function () {
                LEPersonalization.logger.info("save button clicked", "DefaultAgentStatusEditController:_onSave");
                LEPersonalization.loader.setLoader();

                this.siteSettingsModel.setValue(this.currentDefaultAgentStatus.get("value"));
                this.siteSettingsModel.save(null,{
                    success: _.bind(this._onSaveSuccess, this),
                    error: _.bind(this._onSaveError, this)
                });

            },

            _onSaveSuccess: function() {
                LE.siteSettings.agentStatusSettings.switchDefaultAgentStatus(this.currentDefaultAgentStatus.get("value"));
                LEPersonalization.logger.info("default status was saved successfully", "DefaultAgentStatusEditController:_onSaveSuccess");
                LEPersonalization.loader.closeLoader();
                LEPersonalization.navigateToPageMenu();
            },

            _onSaveError: function() {
                LEPersonalization.logger.error("default status was not saved", "DefaultAgentStatusEditController:_onSaveError");
                LEPersonalization.loader.closeLoader();
                LEPersonalization.notifier.showError(LE.translator.translate("LEFramework.errors.serverError.1100"));
            },

            _onCancel: function() {
                LEPersonalization.logger.info("cancel was clicked", "DefaultAgentStatusEditController:_onCancel");
                LEPersonalization.navigateToPageMenu();
            },

            _getEditView: function () {
                return this.defaultAgentStatusEditView;
            }
        });
    });
    return DefaultAgentStatusEditController;

});
